<template>
  <div class="mdrawer">
    <el-row class="m-tab">
      <el-col :span="4" class="m-th">
        <el-tooltip content="订单编号" placement="top"><span
            class="count-style">订单编号</span></el-tooltip>
      </el-col>
      <el-col :span="8" class="m-td">
        <span>{{ flowRecord.order_num }}</span>
      </el-col>
      <el-col :span="4" class="m-th">
        <el-tooltip content="公司名称" placement="top"><span
            class="count-style">公司名称</span></el-tooltip>
      </el-col>
      <el-col :span="8" class="m-td">
        <el-tooltip :content="flowRecord.company_name" placement="top"><span class="count-style">{{ flowRecord.company_name
        }}</span></el-tooltip>
      </el-col>
      <el-col :span="4" class="m-th">
        <el-tooltip content="订单金额" placement="top"><span
            class="count-style">订单金额</span></el-tooltip>
      </el-col>
      <el-col :span="8" class="m-td">
        <el-tooltip :content="flowRecord.total_amount"
          placement="top"><span
            class="count-style">{{ flowRecord.total_amount }}</span></el-tooltip>
      </el-col>
      <el-col :span="4" class="m-th">
        <el-tooltip content="派单时间" placement="top"><span
            class="count-style">派单时间</span></el-tooltip>
      </el-col>
      <el-col :span="8" class="m-td">
        <el-tooltip :content="flowRecord.assign_at" placement="top"><span class="count-style">{{ flowRecord.assign_at
        }}</span></el-tooltip>
      </el-col>
      <el-col :span="4" class="m-th">
        <el-tooltip content="交易流水号" placement="top"><span
            class="count-style">交易流水号</span></el-tooltip>
      </el-col>
      <el-col :span="8" class="m-td">
        <el-tooltip :content="flowRecord.acc_discharge_no" placement="top"><span class="count-style">{{ flowRecord.acc_discharge_no
        }}</span></el-tooltip>
      </el-col>
      <el-col :span="4" class="m-th">
        <el-tooltip content="账号编号" placement="top"><span
            class="count-style">账号编号</span></el-tooltip>
      </el-col>
      <el-col :span="8" class="m-td">
        <el-tooltip :content="flowRecord.account_num" placement="top"><span class="count-style">{{ flowRecord.account_num
        }}</span></el-tooltip>
      </el-col>
      <el-col :span="4" class="m-th">
        <el-tooltip content="账户名称" placement="top"><span
            class="count-style">账户名称</span></el-tooltip>
      </el-col>
      <el-col :span="8" class="m-td">
        <el-tooltip :content="flowRecord.account_name" placement="top"><span class="count-style">{{ flowRecord.account_name
        }}</span></el-tooltip>
      </el-col>
      <el-col :span="4" class="m-th">
        <el-tooltip content="交易时间" placement="top"><span
            class="count-style">交易时间</span></el-tooltip>
      </el-col>
      <el-col :span="8" class="m-td">
        <el-tooltip :content="flowRecord.transfer_time" placement="top"><span
            class="count-style">{{ flowRecord.transfer_time }}</span></el-tooltip>
      </el-col>
      <el-col :span="4" class="m-th">
        <el-tooltip content="借方发生额" placement="top"><span
            class="count-style">借方发生额</span></el-tooltip>
      </el-col>
      <el-col :span="8" class="m-td">
        <el-tooltip :content="flowRecord.creditor" placement="top"><span
            class="count-style">{{ flowRecord.creditor }}</span></el-tooltip>
      </el-col>
      <el-col :span="4" class="m-th">
        <el-tooltip content="贷方发生额" placement="top"><span
            class="count-style">贷方发生额</span></el-tooltip>
      </el-col>
      <el-col :span="8" class="m-td">
        <el-tooltip :content="flowRecord.debtor" placement="top"><span class="count-style">{{ flowRecord.debtor
        }}</span></el-tooltip>
      </el-col>
      <el-col :span="4" class="m-th">
        <el-tooltip content="对方户名" placement="top"><span
            class="count-style">对方户名</span></el-tooltip>
      </el-col>
      <el-col :span="8" class="m-td">
        <el-tooltip :content="flowRecord.other_acc_name" placement="top"><span class="count-style">{{ flowRecord.other_acc_name
        }}</span></el-tooltip>
      </el-col>
      <el-col :span="4" class="m-th">
        <el-tooltip content="对方账户" placement="top"><span
            class="count-style">对方账户</span></el-tooltip>
      </el-col>
      <el-col :span="8" class="m-td">
        <span class="count-style">{{ flowRecord.other_acc_num }}</span>
      </el-col>
      <el-col :span="4" class="m-th">
        <el-tooltip content="凭证种类" placement="top"><span
            class="count-style">凭证种类</span></el-tooltip>
      </el-col>
      <el-col :span="8" class="m-td">
        <span class="count-style">{{ flowRecord.voucher_type }}</span>
      </el-col>
      <el-col :span="4" class="m-th">
        <el-tooltip content="凭证号" placement="top"><span
            class="count-style">凭证号</span></el-tooltip>
      </el-col>
      <el-col :span="8" class="m-td">
        <span class="count-style">{{ flowRecord.voucher_no }}</span>
      </el-col>
      <el-col :span="4" class="m-th">
        <el-tooltip content="记账日期" placement="top"><span
            class="count-style">记账日期</span></el-tooltip>
      </el-col>
      <el-col :span="8" class="m-td">
        <span class="count-style">{{ flowRecord.book_date }}</span>
      </el-col>
      <el-col :span="4" class="m-th">
        <el-tooltip content="备注" placement="top"><span
            class="count-style">备注</span></el-tooltip>
      </el-col>
      <el-col :span="8" class="m-td">
        <span class="count-style">{{ flowRecord.remark }}</span>
      </el-col>
    </el-row>

    <el-row class="m-tab" style="margin-top:0.2rem">
      <el-col :span="4" class="m-th" style="height: 100px;line-height:100px;">
        <el-tooltip content="收款凭证" placement="top"><span
            class="count-style">收款凭证</span></el-tooltip>
      </el-col>
      <span v-if="evidenceUrlList.length > 0">
        <el-col :span="20" class="m-td" style="height:100px;line-height:100px;border-right: 1px solid #dee2e6;border-bottom: 1px solid #dee2e6;">
          <div style="display: inline-block;" v-for="img in evidenceUrlList" :key="index">
            <el-image
            style="width: 90px;height: 90px;margin: 5px 0px 5px 10px;line-height:90px"
            :src="img.url"
            :preview-src-list="bigPreviewList"
            fit="fill"></el-image>
          </div>
        </el-col>
      </span>
      <span v-else style="color:#E6A23C;font-size: small">
        <el-col :span="20" class="m-td" style="height:100px;line-height:100px;border-right: 1px solid #dee2e6;border-bottom: 1px solid #dee2e6;">
          暂无凭证!
        </el-col>
      </span>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'FlowDetail',
  props: { flowNumber: String },
  data () {
    return {
      flowNo: '',
      flowRecord: {
        order_num: '',
        company_name: '',
        total_amount: '',
        assign_at: '',
        acc_discharge_no: '',
        account_num: '',
        account_name: '',
        transfer_time: '',
        creditor: '',
        debtor: '',
        other_acc_name: '',
        other_acc_num: '',
        voucher_type: '',
        voucher_no: '',
        book_date: '',
        remark: ''
      },
      evidenceUrlList: [],
      bigPreviewList: []
    }
  },
  watch: {
    flowNumber: function(val) {
      this.flowNo = val || ''
      if (val) {
        this.getFlowNumber()
      }
    }
  },
  methods: {
    getFlowNumber() {
      this.evidenceUrlList = []
      this.bigPreviewList = []
      this.$axios
        .get('api/tyc_order/get_flow_detail', {
          params: {
            acc_discharge_no: this.flowNo
          },
        })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.flowRecord.order_num = data.data.flowRecord.tycorder.order_num
            this.flowRecord.company_name = data.data.flowRecord.tycorder.company_obj.company_name
            this.flowRecord.total_amount = data.data.flowRecord.tycorder.total_amount
            this.flowRecord.assign_at = data.data.flowRecord.tycorder.assign_at
            this.flowRecord.acc_discharge_no = data.data.flowRecord.acc_discharge_no
            this.flowRecord.account_num =  data.data.flowRecord.account_num
            this.flowRecord.account_name = data.data.flowRecord.account_name
            this.flowRecord.transfer_time = data.data.flowRecord.transfer_time
            this.flowRecord.creditor = data.data.flowRecord.creditor
            this.flowRecord.debtor = data.data.flowRecord.debtor
            this.flowRecord.other_acc_name = data.data.flowRecord.other_acc_name
            this.flowRecord.other_acc_num = data.data.flowRecord.other_acc_num
            this.flowRecord.voucher_type = data.data.flowRecord.voucher_type
            this.flowRecord.voucher_no = data.data.flowRecord.voucher_no
            this.flowRecord.book_date = data.data.flowRecord.book_date
            this.flowRecord.remark = data.data.flowRecord.remark
            if (data.data.flowRecord.tycorder.receipt_pic) {
              for (let i = 0; i < data.data.flowRecord.tycorder.receipt_pic.length; i++) {
                this.evidenceUrlList.push({ url: data.data.flowRecord.tycorder.receipt_pic[i].receive_url })
                this.bigPreviewList.push(data.data.flowRecord.tycorder.receipt_pic[i].receive_url)
              }
            }
          } else {
            this.clearFlowData()
            this.evidenceUrlList = []
            this.bigPreviewList = []
            this.$message.error(data.msg)
          }
        })
    },
    clearFlowData() {
      this.flowRecord.order_num = ''
      this.flowRecord.company_name = ''
      this.flowRecord.total_amount = ''
      this.flowRecord.assign_at = ''
      this.flowRecord.acc_discharge_no = ''
      this.flowRecord.account_num =  ''
      this.flowRecord.account_name = ''
      this.flowRecord.transfer_time = ''
      this.flowRecord.creditor = ''
      this.flowRecord.debtor = ''
      this.flowRecord.other_acc_name = ''
      this.flowRecord.other_acc_num = ''
      this.flowRecord.voucher_type = ''
      this.flowRecord.voucher_no = ''
      this.flowRecord.book_date = ''
      this.flowRecord.remark =  ''
    }
  }
}
</script>
<style scoped lang="stylus">
.mstyle_first {
  border: 1px solid #ccc;
  border-bottom: none;
  height: 1rem;
  line-height: 1rem;
}

.mstyle_first>* {
  border-right: 1px solid #ccc;
  white-space: nowrap;
}

.mdrawer {
  .count-style {
    display: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .m-tab {
    border-top: 1px solid #dee2e6;
    border-left: 1px solid #dee2e6;
  }

  .m-th {
    height: 42px;
    line-height: 42px;
    padding: 0 5px;
    border-bottom: 1px solid #dee2e6;
    color: #909399;
    background: #fafafa;
  }

  .m-td {
    height: 42px;
    line-height: 42px;
    padding: 0 5px;
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6;
    border-bottom: 1px solid #dee2e6;
  }
}

.mstyle_s {
  border: 1px solid #ccc;
  border-bottom: none;
  height: 1rem;
  line-height: 1rem;
}

.mstyle_s>* {
  border-right: 1px solid #ccc;
  white-space: nowrap;
}

.title-bg{
  color: #909399;
  background: #fafafa;

}

.right-border{
  border-right: none;
}

.title-border{
  border-bottom: 1px solid #dee2e6;
}
/* .mstyle_s :nth-child(odd) {
  background-color: #f0f9eb;
} */
/* .mstyle_s :nth-child(even) {
  background-color: oldlace;
} */


.lbottom {
  border-bottom: 1px solid #dee2e6;
}
</style>



// WEBPACK FOOTER //
// src/common/FlowDetail.vue